import React, {useEffect, useRef, useState} from "react";
import "./Blog.scss"
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import 'swiper/swiper-bundle.min.css'
import {useHistory, useLocation} from "react-router-dom";
import {Nav} from "../../Components";
import {BlogList_api, EventsData, ServiceList_api} from "./BlogServices";
import {ServiceTags_api,BlogsTags_api} from "../Service/ServiceServices";



const ServiceCard= ({service,history})=>{
    return(
        <div className="blog-card" onClick={()=>history.push(`/service-detail/${service.uid}`,{event:service})}
             // style={{backgroundImage: `url(${service .cover})`}}
        >
            <img src={service.cover} alt=""/>
            <div className="blog-card-info">
                <span className="blog-card-title">{service.title}</span>
                {service.body?<span className="blog-card-sub">{service.body.substr(0,150)}<i className="blog-card-sub-read-more">بیشتر بخوانید</i></span>:null}
            </div>
        </div>
    )
}

function Blog() {


    const location = useLocation()
    //hooks
    const history = useHistory();
    const MyRef = useRef(null);

    //states
    const [events,setEvents] = useState(null);
    const [introduction,setIntroduction] = useState(null);
    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);
    const [nav_label,set_nav_label] = useState(null)

    // TSliderDesktop Functions -------------------------------------
    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }


    useEffect(()=>{
        if(location.state && location.state.navLabel)
            set_nav_label(location.state.navLabel)
    },[])

    useEffect(()=>{
        getEvents();
        getCat();
        // swiper.current=new Swiper('.swiper-container',{
        //     loop:true,
        //     autoplay: {
        //         delay: 5000,
        //     },
        // })
        //Loop();
    },[])


    const [cats,setCats] = useState([])
    const [currentCat,set_currentCat] = useState([])

    const getCat = async () => {
        try{
            const response = await BlogsTags_api();
            setCats(response.data);
            setPreload(false);

            if(location.state && location.state.tagLink){
                console.log("Tag LINK : ",location.state.tagLink)
                selectCat(location.state.tagLink)
            }else{
                selectCat({uid:1})
            }
        }catch (e) {
            setPreload(false);
        }
    }

    const selectCat = (tag)=>{
        set_currentCat(tag)
        if(tag.uid!==1)
            getEvents(tag.uid)
        else
            getEvents()
    }


    //fetch events ------------------------------------------------------
    const getEvents = async (tagId=null) => {
        try{
            let response = await BlogList_api(tagId);
            setEvents(response.data)
            setPreload(false)
        }catch (e) {
            setFailed(true)
            // console.log(e);
        }
    }
    const params = {
        slidesPerView: 'auto',
        spaceBetween: 15,
        // rebuildOnUpdate : true,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }


    const newParams = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }

    const calcTextWidth = (text)=>{
        let length = text.length;
        if(length<4)
            return length*15

        if(length>10)
            return  length*8;

        return length*12
    }

    return(
        <div className="events-container page">
            <div className="events-header">
                <span>{nav_label?nav_label:"وبلاگ"}</span>
            </div>


            <div className="blog-categories">
                {cats.length>0?<Swiper {...newParams}>
                    <div key={1}  onClick={()=>{selectCat({uid:1})}} style={{width:calcTextWidth("همه")}} className={currentCat.uid===1?"slide-a":"slide-deselect-a"}  >
                        همه
                    </div>
                    {cats.map(cat=>{
                        return (
                            <div key={cat.uid} onClick={()=>{selectCat(cat)}} style={{width:calcTextWidth(cat.name)}} className={currentCat.uid===cat.uid?"slide-a":"slide-deselect-a"}  >
                                {cat.name}
                            </div>
                        )
                    })}
                </Swiper>:null}
            </div>


            {/*<div className="blog-categories">*/}
            {/*    /!*OnlineStoreSubCat List*!/*/}
            {/*    <div className="store-categories-list">*/}
            {/*        {cats.length>0?  <Swiper ref={MyRef}  {...params}>*/}
            {/*            <div key={1}*/}
            {/*                 onClick={()=>{selectCat({uid:1})}}*/}
            {/*                 className="store-categories-item">*/}
            {/*                        <span className={currentCat.uid===1?"cat_select":"cat_deselect"}>همه*/}
            {/*                            /!*<i className="fa fa-user"></i>*!/*/}
            {/*                        </span>*/}
            {/*                <img src={"https://s3.mobank.co/loyalty-media/merchant/category/images/poshak.png"}  alt="" style={{width:'100%'}}/>*/}
            {/*            </div>*/}
            {/*            {cats.map(cat=>{*/}
            {/*                return (*/}
            {/*                    <div key={cat.uid}*/}
            {/*                         onClick={()=>{selectCat(cat)}}*/}
            {/*                         className="store-categories-item">*/}
            {/*                        <span className={currentCat.uid===cat.uid?"cat_select":"cat_deselect"}>{cat.name}*/}
            {/*                            /!*<i className="fa fa-user"></i>*!/*/}
            {/*                        </span>*/}
            {/*                        <img src={cat.image}  alt="" style={{width:'100%'}}/>*/}
            {/*                    </div>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*        </Swiper>:null}*/}
            {/*    </div>*/}
            {/*</div>*/}



            {!preload?<div>
               <div className="service_lis">

                   {events && events.map(event=>{

                       return(
                           <ServiceCard service={event} history={history}/>
                           // <div key={event.uid} className="events_list_item" onClick={()=>history.push(`/service-detail/${event.uid}`,{event:event})}>
                           //     <div className="events_list_item_info">
                           //         <span className="events_list_item_title">{event.title}</span>
                           //         <span className="events_list_item_date">{event.subtitle}</span>
                           //         {/*<span className="events_list_item_time">ساعت 23:59</span>*/}
                           //     </div>
                           //     <img src={event.image || event.cover} alt=""/>
                           // </div>
                       )
                   })

                   }

               </div>
           </div>: <div className="customer-preLoading">
            {!failed ? <div className="customer-preloading-body">
                <img src="/svg/pre.gif" alt=""/>
            </div> : <div className="customer-failed-body">
                <img src="/svg/failed.svg" alt=""/>
                <span>اطلاعاتی موجود نیست</span>
            </div>}
        </div>}
            <Nav/>
        </div>
    )

}

export {Blog};
